import {
  RECOMMENDATION_TYPES,
} from '@bingads-webui-campaign/recommendation-core';

const defaultParser = (i18n, value) => i18n.parseDecimal(value);

// for each type, key is MT field, value is UI property name used in recommendation-config.js.
export const userInputsMappingConfigForForm = {
  [RECOMMENDATION_TYPES.BUDGET]: {
    NewBudget: {
      property: 'budgetSuggested',
      parser: defaultParser,
    },
  },
  // deprecated in Oct 2023
  [RECOMMENDATION_TYPES.NEW_KEYWORD]: {
    NewBid: {
      property: 'suggestedBid',
      parser: defaultParser,
    },
    MatchType: {
      property: 'matchType',
      parser: defaultParser,
    },
    TargetAdGroupId: {
      property: 'AdGroupId',
      isFromTarget: true,
    },
  },
};

export const userInputsMappingConfigForGrid = {
  [RECOMMENDATION_TYPES.COMPETITIVE_BID]: {
    selected: {
      nameInRequest: 'NewBid',
      property: 'suggestedBid',
    },
  },
  [RECOMMENDATION_TYPES.DEVICE_BID_BOOST]: {
    selected: {
      nameInRequest: 'NewBidBoost',
      property: 'suggestedBidAdjustmentPercent',
    },
  },
  [RECOMMENDATION_TYPES.LOCATION_BID_BOOST]: {
    selected: {
      nameInRequest: 'NewBidBoost',
      property: 'suggestedBidAdjustmentPercent',
    },
  },
  [RECOMMENDATION_TYPES.NEW_LOCATION]: {
    // no inputs besides opportunity id
  },
  [RECOMMENDATION_TYPES.SYNDICATION]: {
    // no inputs besides opportunity id
  },
};
